import { db } from "../../../config/firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";

/**
 * Custom hook for handling session deletion
 * @param {Object} userInfo - User information from Redux store
 * @returns {Function} handleDeleteSession - Function to delete a session
 */
export const useSessionDeletion = (userInfo) => {
  const { t } = useTranslation();

  const handleDeleteSession = async (sessionId) => {
    // Validation
    if (!userInfo?.email || !userInfo?.uid) {
      alert(t("history.gameHistory.noUserFound"));
      return;
    }

    // Confirmation
    const confirmDelete = window.confirm(
      t("history.gameHistory.confirmDelete")
    );
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "userInfo", userInfo.uid, "sessions", sessionId));
    } catch (error) {
      console.error("Error deleting session:", error);
      alert(t("history.gameHistory.failedToDelete"));
    }
  };

  return handleDeleteSession;
};
